import React, { memo } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import { inject, observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import { systemName } from '../../../config'
import AppPageHeader from '../../../components/AppPageHeader'
import DashboardLayout from '../../../layouts/DashboardLayout'
import InternalDocumentOutgoingDocCreateForm from './InternalDocumentOutgoingDocCreateForm'

const InternalDocumentOutgoingDocCreatePage = props => {
  const { authenticationStore } = props

  const history = useHistory()

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạo văn bản đi | Quản lý VB {systemName}</title>
      </Helmet>
      <AppPageHeader title="Tạo văn bản đi" />

      <InternalDocumentOutgoingDocCreateForm
        handleCancel={() =>
          history.push('/internal-document/outgoing-document')
        }
      />
    </DashboardLayout>
  )
}

InternalDocumentOutgoingDocCreatePage.propTypes = {}

export default memo(
  inject('authenticationStore')(observer(InternalDocumentOutgoingDocCreatePage))
)
